import * as React from "react";
import {Component} from "react";
import Select, {components} from "react-select";
import { ChangeInputAction } from "./CreatableSelectTypes";

const dropdownIndicatorStyle: React.CSSProperties = {
    right: "10px",
};

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <div style={dropdownIndicatorStyle}>▾</div>
        </components.DropdownIndicator>
    );
};

interface SelectOption<T = string> {
    label: string;
    value: T;
}

type OptionsType = Array<any>;

interface SelectComponentProps {
    classNames?: string;
    disabled?: boolean;
    inputValue?: string;
    value: SelectOption;
    options: OptionsType;
    placeholder?: string;
    menuIsOpen?: boolean;
    useOptionFontStyle?: boolean;
    formatGroupLabel?(data: any): React.ReactElement;
    onMenuOpen?(): void;
    onChange?(e: SelectOption): void;
    onInputChange?(inputValue: string, actionMeta: ChangeInputAction);
}

class SelectComponent extends Component<SelectComponentProps> {
    constructor(props: SelectComponentProps) {
        super(props);
    }

    render() {
        const selectStyles = {
            control: (providedStyles) => ({
                ...providedStyles,
                backgroundColor: "#333333",
                color: "white",
                borderRadius: 0,
                border: "none",
                width: "auto",
                height: "25px",
                minHeight: "25px",
                boxShadow: "none",
                "&:hover": {
                    border: "none",
                    boxShadow: "none",
                }
            }),
            input: (providedStyles) => ({
                ...providedStyles,
                color: "white",
                padding: "0px",
                margin: "0px",
            }),
            singleValue: (providedStyles) => ({
                ...providedStyles,
                color: "white",
                height: "25px",
                lineHeight: "25px",
                position: "relative",
                transition: "none",
                top: "6px",
            }),
            indicatorsContainer: (providedStyles) => ({
                ...providedStyles,
                color: "#C6C6C6",
                maxHeight: "25px",
            }),
            menu: (providedStyles) => ({
                ...providedStyles,
                width: "100%",
                borderRadius: "0px",
                marginTop: "4px",
                marginBottom: "0px",
            }),
            menuList: (providedStyles) => ({
                ...providedStyles,
                marginTop: "0px",
                marginBottom: "0px",
            }),
            option: (providedStyles, props) => ({
                ...providedStyles,
                paddingTop: "0px",
                paddingBottom: "0px",
                color: "#000000",
                backgroundColor: props.isSelected ? "#868686" : props.data.__isNew__ && "#DEEBFF",
                ...(this.props.useOptionFontStyle && {fontFamily: props.data.value}),
                "&:hover": {
                    backgroundColor: "#868686"
                }
            }),
            valueContainer: (providedStyles) => ({
                ...providedStyles,
                maxHeight: "25px",
                overflow: "unset",
                minWidth: "0px",
            }),
        };

        const {
            onChange,
            options,
            value,
            placeholder,
            onMenuOpen,
            inputValue,
            formatGroupLabel,
            onInputChange,
            classNames,
            disabled,
            menuIsOpen
        } = this.props;
        return(
            <Select
                onChange={onChange}
                options={options}
                value={value}
                placeholder={placeholder}
                getOptionLabel={({label}) => label}
                // @ts-ignore
                getOptionValue={({value: optionValue}) => optionValue}
                onMenuOpen={onMenuOpen}
                styles={selectStyles}
                components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator
                }}
                onInputChange={onInputChange}
                inputValue={inputValue}
                formatGroupLabel={formatGroupLabel}
                classNames={classNames}
                isDisabled={disabled}
                menuIsOpen={menuIsOpen}
            />
        );
    }
}

export {
    SelectComponent as default,
    SelectComponent,
    SelectOption
};



// WEBPACK FOOTER //
// ./src/shared/ui/common/SelectComponent.tsx